export const PAGE_TYPES = [
  { value: 'static',         label: 'Página fija',      icon: 'insert_drive_file', color: '#607d8b' },
  { value: 'dynamic_list',   label: 'Listado dinámico', icon: 'view_list',         color: '#f57c00' },
  { value: 'dynamic_detail', label: 'Detalle dinámico', icon: 'article',           color: '#7b1fa2' },
];

export const CONTENT_TYPES = [
  {
    value: 'blog',
    label: 'Blog / Noticias',
    icon: 'article',
    fields: [
      { key: 'titulo',    label: 'Título',    type: 'text',     icon: 'title' },
      { key: 'fecha',     label: 'Fecha',     type: 'date',     icon: 'calendar_today' },
      { key: 'imagen',    label: 'Imagen',    type: 'image',    icon: 'image' },
      { key: 'resumen',   label: 'Resumen',   type: 'text',     icon: 'short_text' },
      { key: 'contenido', label: 'Contenido', type: 'richtext', icon: 'text_snippet' },
      { key: 'autor',     label: 'Autor',     type: 'text',     icon: 'person' },
      { key: 'categoria', label: 'Categoría', type: 'text',     icon: 'label' },
    ],
  },
  {
    value: 'catalog',
    label: 'Catálogo de productos',
    icon: 'shopping_bag',
    fields: [
      { key: 'nombre',      label: 'Nombre',      type: 'text',    icon: 'title' },
      { key: 'precio',      label: 'Precio',      type: 'text',    icon: 'attach_money' },
      { key: 'imagen',      label: 'Imagen',      type: 'image',   icon: 'image' },
      { key: 'descripcion', label: 'Descripción', type: 'text',    icon: 'description' },
      { key: 'categoria',   label: 'Categoría',   type: 'text',    icon: 'label' },
      { key: 'disponible',  label: 'Disponible',  type: 'boolean', icon: 'check_circle' },
    ],
  },
  {
    value: 'gallery',
    label: 'Galería',
    icon: 'photo_library',
    fields: [
      { key: 'titulo',      label: 'Título',      type: 'text',  icon: 'title' },
      { key: 'imagen',      label: 'Imagen',      type: 'image', icon: 'image' },
      { key: 'descripcion', label: 'Descripción', type: 'text',  icon: 'description' },
      { key: 'categoria',   label: 'Categoría',   type: 'text',  icon: 'label' },
    ],
  },
  {
    value: 'faq',
    label: 'Preguntas frecuentes',
    icon: 'help_outline',
    fields: [
      { key: 'pregunta',  label: 'Pregunta',  type: 'text',     icon: 'help' },
      { key: 'respuesta', label: 'Respuesta', type: 'richtext', icon: 'question_answer' },
      { key: 'categoria', label: 'Categoría', type: 'text',     icon: 'label' },
    ],
  },
  {
    value: 'team',
    label: 'Equipo',
    icon: 'group',
    fields: [
      { key: 'nombre',      label: 'Nombre',      type: 'text',  icon: 'person' },
      { key: 'cargo',       label: 'Cargo',       type: 'text',  icon: 'work' },
      { key: 'foto',        label: 'Foto',        type: 'image', icon: 'portrait' },
      { key: 'descripcion', label: 'Descripción', type: 'text',  icon: 'description' },
    ],
  },
];

export const getContentType = (value) =>
  CONTENT_TYPES.find((ct) => ct.value === value) || null;

export const getPageType = (value) =>
  PAGE_TYPES.find((pt) => pt.value === value) || PAGE_TYPES[0];

export const SECTION_TYPES = [
  {
    value: 'hero_banner',
    label: 'Banner principal',
    icon: 'photo',
    description: 'Imagen de fondo con título y llamada a la acción',
    canBelist: true,
    listLabel: 'Carrusel de banners',
    defaultFields: [
      { key: 'imagen',      label: 'Imagen',          type: 'image', required: true },
      { key: 'titulo',      label: 'Título',           type: 'text',  required: false },
      { key: 'subtitulo',   label: 'Subtítulo',        type: 'text',  required: false },
      { key: 'texto_boton', label: 'Texto del botón',  type: 'text',  required: false },
      { key: 'url_boton',   label: 'URL del botón',    type: 'url',   required: false },
    ],
  },
  {
    value: 'card',
    label: 'Tarjeta de contenido',
    icon: 'credit_card',
    description: 'Tarjeta con imagen, título y descripción',
    canBelist: true,
    listLabel: 'Lista de tarjetas',
    defaultFields: [
      { key: 'titulo',      label: 'Título',      type: 'text',     required: true },
      { key: 'descripcion', label: 'Descripción', type: 'text',     required: false },
      { key: 'imagen',      label: 'Imagen',      type: 'image',    required: false },
      { key: 'detalle',     label: 'Detalle',     type: 'richtext', required: false },
      { key: 'url',         label: 'Enlace',      type: 'url',      required: false },
    ],
  },
  {
    value: 'video',
    label: 'Video',
    icon: 'play_circle_filled',
    description: 'Reproductor de video (YouTube, Vimeo, etc.)',
    canBelist: true,
    listLabel: 'Lista de videos',
    defaultFields: [
      { key: 'url',    label: 'URL del video', type: 'url',  required: true },
      { key: 'titulo', label: 'Título',        type: 'text', required: false },
    ],
  },
  {
    value: 'text_block',
    label: 'Bloque de texto',
    icon: 'notes',
    description: 'Título y párrafos de texto libre',
    canBelist: false,
    defaultFields: [
      { key: 'titulo',    label: 'Título',    type: 'text',     required: false },
      { key: 'contenido', label: 'Contenido', type: 'richtext', required: true },
    ],
  },
  {
    value: 'gallery',
    label: 'Galería de imágenes',
    icon: 'photo_library',
    description: 'Colección de imágenes con título',
    canBelist: true,
    listLabel: 'Imágenes de la galería',
    defaultFields: [
      { key: 'imagen',      label: 'Imagen',      type: 'image', required: true },
      { key: 'titulo',      label: 'Título',      type: 'text',  required: false },
      { key: 'descripcion', label: 'Descripción', type: 'text',  required: false },
    ],
  },
  {
    value: 'contact_form',
    label: 'Formulario de contacto',
    icon: 'contact_mail',
    description: 'Formulario para recibir mensajes de clientes',
    canBelist: false,
    defaultFields: [
      { key: 'titulo',        label: 'Título del formulario', type: 'text', required: false },
      { key: 'email_destino', label: 'Email destino',         type: 'text', required: true },
    ],
  },
  {
    value: 'footer',
    label: 'Pie de página',
    icon: 'vertical_align_bottom',
    description: 'Información de contacto y links al pie del sitio',
    canBelist: false,
    defaultFields: [
      { key: 'texto',     label: 'Texto',     type: 'text', required: false },
      { key: 'email',     label: 'Email',     type: 'text', required: false },
      { key: 'telefono',  label: 'Teléfono',  type: 'text', required: false },
      { key: 'direccion', label: 'Dirección', type: 'text', required: false },
    ],
  },
  // ── Tipografía ───────────────────────────────────────────────────────────────
  {
    value: 'heading_h1',
    label: 'Título H1',
    icon: 'title',
    description: 'Título principal de sección o página',
    isTypography: true,
    canBelist: false,
    defaultFields: [
      { key: 'texto',     label: 'Texto del título',  type: 'text', required: true  },
      { key: 'subtexto',  label: 'Subtexto opcional', type: 'text', required: false },
    ],
  },
  {
    value: 'heading_h2',
    label: 'Título H2',
    icon: 'title',
    description: 'Título secundario o de subsección',
    isTypography: true,
    canBelist: false,
    defaultFields: [
      { key: 'texto',     label: 'Texto del título',  type: 'text', required: true  },
      { key: 'subtexto',  label: 'Subtexto opcional', type: 'text', required: false },
    ],
  },
  {
    value: 'heading_h3',
    label: 'Título H3',
    icon: 'text_fields',
    description: 'Subtítulo o encabezado terciario',
    isTypography: true,
    canBelist: false,
    defaultFields: [
      { key: 'texto', label: 'Texto del título', type: 'text', required: true },
    ],
  },
  {
    value: 'paragraph_text',
    label: 'Párrafo',
    icon: 'notes',
    description: 'Bloque de texto enriquecido libre',
    isTypography: true,
    canBelist: false,
    defaultFields: [
      { key: 'contenido', label: 'Contenido', type: 'richtext', required: true },
    ],
  },
  {
    value: 'text_label',
    label: 'Etiqueta / Texto pequeño',
    icon: 'text_snippet',
    description: 'Texto breve: leyenda, aviso, nota al pie',
    isTypography: true,
    canBelist: false,
    defaultFields: [
      { key: 'texto', label: 'Texto', type: 'text', required: true },
    ],
  },
  // ── Layouts / Contenedores ──────────────────────────────────────────────────
  {
    value: 'product_cards',
    label: 'Cards de Productos',
    icon: 'shopping_bag',
    description: 'Grid de tarjetas con imagen, precio y enlace',
    isContainer: true,
    canBelist: true,
    listLabel: 'Productos',
    defaultDisplay: 'grid_3',
    defaultFields: [
      { key: 'imagen',      label: 'Imagen',      type: 'image', required: false },
      { key: 'nombre',      label: 'Nombre',      type: 'text',  required: true  },
      { key: 'precio',      label: 'Precio',      type: 'text',  required: false },
      { key: 'descripcion', label: 'Descripción', type: 'text',  required: false },
      { key: 'url',         label: 'Ver más',     type: 'url',   required: false },
    ],
  },
  {
    value: 'service_cards',
    label: 'Cards de Servicios',
    icon: 'build',
    description: 'Grid de servicios con ícono y descripción',
    isContainer: true,
    canBelist: true,
    listLabel: 'Servicios',
    defaultDisplay: 'grid_3',
    defaultFields: [
      { key: 'imagen',      label: 'Imagen / Ícono', type: 'image', required: false },
      { key: 'titulo',      label: 'Título',          type: 'text',  required: true  },
      { key: 'descripcion', label: 'Descripción',     type: 'text',  required: false },
      { key: 'url',         label: 'Ver más',         type: 'url',   required: false },
    ],
  },
  {
    value: 'team_cards',
    label: 'Cards de Equipo',
    icon: 'group',
    description: 'Perfiles de equipo con foto, nombre y cargo',
    isContainer: true,
    canBelist: true,
    listLabel: 'Integrantes',
    defaultDisplay: 'grid_4',
    defaultFields: [
      { key: 'foto',        label: 'Foto',        type: 'image', required: false },
      { key: 'nombre',      label: 'Nombre',      type: 'text',  required: true  },
      { key: 'cargo',       label: 'Cargo',       type: 'text',  required: false },
      { key: 'descripcion', label: 'Descripción', type: 'text',  required: false },
    ],
  },
  {
    value: 'testimonials',
    label: 'Testimonios',
    icon: 'format_quote',
    description: 'Opiniones de clientes con foto y comentario',
    isContainer: true,
    canBelist: true,
    listLabel: 'Testimonios',
    defaultDisplay: 'carousel',
    defaultFields: [
      { key: 'nombre',  label: 'Nombre',         type: 'text',     required: true  },
      { key: 'cargo',   label: 'Cargo / Empresa', type: 'text',     required: false },
      { key: 'foto',    label: 'Foto',            type: 'image',    required: false },
      { key: 'texto',   label: 'Comentario',      type: 'richtext', required: true  },
    ],
  },
  {
    value: 'faq_accordion',
    label: 'Preguntas Frecuentes',
    icon: 'help_outline',
    description: 'Acordeón de preguntas y respuestas',
    isContainer: true,
    canBelist: true,
    listLabel: 'Preguntas',
    defaultDisplay: 'list',
    defaultFields: [
      { key: 'pregunta',  label: 'Pregunta',  type: 'text',     required: true },
      { key: 'respuesta', label: 'Respuesta', type: 'richtext', required: true },
    ],
  },
  {
    value: 'search_bar',
    label: 'Buscador',
    icon: 'search',
    description: 'Barra de búsqueda con título opcional',
    isContainer: true,
    canBelist: false,
    defaultFields: [
      { key: 'titulo',      label: 'Título',           type: 'text', required: false },
      { key: 'placeholder', label: 'Texto de ejemplo', type: 'text', required: false },
    ],
  },
  {
    value: 'visual_cards',
    label: 'Cards con Badge',
    icon: 'view_module',
    description: 'Cards visuales con imagen, descripción, etiqueta y botón',
    isContainer: true,
    canBelist: true,
    listLabel: 'Cards',
    defaultDisplay: 'grid_3',
    cardPreview: true,
    defaultFields: [
      { key: 'imagen',      label: 'Imagen',            type: 'image', required: false },
      { key: 'titulo',      label: 'Título',             type: 'text',  required: true  },
      { key: 'descripcion', label: 'Descripción',        type: 'text',  required: false },
      { key: 'badge',       label: 'Etiqueta / Badge',   type: 'text',  required: false },
      { key: 'persona',     label: 'Autor / Persona',    type: 'text',  required: false },
      { key: 'slug',        label: 'Slug (URL única)',    type: 'text',  required: false },
      { key: 'url',         label: 'Enlace',             type: 'url',   required: false },
      { key: 'texto_boton', label: 'Texto del botón',    type: 'text',  required: false },
    ],
  },
  // ── Plantillas de detalle ──────────────────────────────────────────────────
  {
    value: 'detail_block',
    label: 'Bloque de Detalle',
    icon: 'auto_awesome',
    description: 'Plantilla visual para la página de detalle de un elemento',
    isDetailTemplate: true,
    canBelist: true,
    listLabel: 'Elementos',
    defaultFields: [],
  },
];

export const DETAIL_TEMPLATES = [
  {
    value: 'article',
    label: 'Artículo / Blog',
    icon: 'article',
    description: 'Imagen destacada, título, autor y contenido enriquecido',
    color: '#1565c0',
    preview: ['imagen', 'titulo', 'badge', 'persona', 'descripcion', 'contenido'],
  },
  {
    value: 'product',
    label: 'Producto / Servicio',
    icon: 'shopping_bag',
    description: 'Imagen, precio, descripción y botón de acción',
    color: '#2e7d32',
    preview: ['imagen', 'titulo', 'precio', 'descripcion', 'texto_boton'],
  },
  {
    value: 'profile',
    label: 'Perfil / Persona',
    icon: 'account_circle',
    description: 'Foto circular, nombre, cargo y biografía',
    color: '#6a1b9a',
    preview: ['foto', 'nombre', 'cargo', 'descripcion', 'contenido'],
  },
  {
    value: 'minimal',
    label: 'Vista Minimal',
    icon: 'notes',
    description: 'Imagen, título y contenido en diseño limpio',
    color: '#37474f',
    preview: ['imagen', 'titulo', 'descripcion', 'contenido'],
  },
];

export const getDetailTemplate = (value) =>
  DETAIL_TEMPLATES.find((dt) => dt.value === value) || DETAIL_TEMPLATES[0];

export const DETAIL_TEMPLATE_FIELDS = {
  article: [
    { key: 'titulo',      label: 'Título',           type: 'text',     required: true  },
    { key: 'slug',        label: 'Slug (URL única)',  type: 'text',     required: true  },
    { key: 'imagen',      label: 'Imagen (URL)',      type: 'text',     required: false },
    { key: 'badge',       label: 'Categoría / Badge', type: 'text',     required: false },
    { key: 'fecha',       label: 'Fecha',             type: 'text',     required: false },
    { key: 'persona',     label: 'Autor',             type: 'text',     required: false },
    { key: 'descripcion', label: 'Resumen',           type: 'text',     required: false },
    { key: 'contenido',   label: 'Contenido',         type: 'richtext', required: false },
  ],
  product: [
    { key: 'titulo',      label: 'Nombre del producto', type: 'text',     required: true  },
    { key: 'slug',        label: 'Slug (URL única)',     type: 'text',     required: true  },
    { key: 'imagen',      label: 'Imagen (URL)',         type: 'text',     required: false },
    { key: 'badge',       label: 'Etiqueta',             type: 'text',     required: false },
    { key: 'precio',      label: 'Precio',               type: 'text',     required: false },
    { key: 'descripcion', label: 'Descripción corta',    type: 'text',     required: false },
    { key: 'contenido',   label: 'Descripción detallada',type: 'richtext', required: false },
    { key: 'texto_boton', label: 'Texto del botón',      type: 'text',     required: false },
  ],
  profile: [
    { key: 'nombre',      label: 'Nombre',            type: 'text',     required: true  },
    { key: 'slug',        label: 'Slug (URL única)',   type: 'text',     required: true  },
    { key: 'foto',        label: 'Foto (URL)',         type: 'text',     required: false },
    { key: 'cargo',       label: 'Cargo / Rol',        type: 'text',     required: false },
    { key: 'descripcion', label: 'Resumen',            type: 'text',     required: false },
    { key: 'contenido',   label: 'Biografía',          type: 'richtext', required: false },
  ],
  minimal: [
    { key: 'titulo',      label: 'Título',           type: 'text',     required: true  },
    { key: 'slug',        label: 'Slug (URL única)',  type: 'text',     required: true  },
    { key: 'imagen',      label: 'Imagen (URL)',      type: 'text',     required: false },
    { key: 'descripcion', label: 'Descripción',       type: 'text',     required: false },
    { key: 'contenido',   label: 'Contenido',         type: 'richtext', required: false },
  ],
};

export const FIELD_TYPES = [
  { value: 'text',     label: 'Texto corto' },
  { value: 'richtext', label: 'Texto enriquecido' },
  { value: 'image',    label: 'Imagen (URL)' },
  { value: 'url',      label: 'URL / Enlace' },
  { value: 'date',     label: 'Fecha' },
  { value: 'number',   label: 'Número' },
  { value: 'boolean',  label: 'Sí / No' },
];

export const getSectionType = (value) =>
  SECTION_TYPES.find((st) => st.value === value) || null;

export const DISPLAY_OPTIONS = [
  { value: 'carousel', label: 'Carrusel' },
  { value: 'grid_2',   label: 'Grid 2 col.' },
  { value: 'grid_3',   label: 'Grid 3 col.' },
  { value: 'grid_4',   label: 'Grid 4 col.' },
  { value: 'list',     label: 'Lista vertical' },
];

export const PADDING_OPTIONS = [
  { value: 'none', label: 'Ninguno' },
  { value: 'sm',   label: 'S' },
  { value: 'md',   label: 'M' },
  { value: 'lg',   label: 'L' },
];

export const COL_SPAN_OPTIONS = [
  { value: 12, label: 'Ancho completo (100%)' },
  { value: 8,  label: 'Dos tercios (66%)' },
  { value: 6,  label: 'Mitad (50%)' },
  { value: 4,  label: 'Un tercio (33%)' },
];

export const getDefaultDisplay = (type, isList) => {
  if (!isList) return 'single';
  if (type === 'hero_banner' || type === 'video' || type === 'testimonials') return 'carousel';
  if (type === 'faq_accordion') return 'list';
  if (type === 'team_cards') return 'grid_4';
  return 'grid_3';
};
